import { Pipe, PipeTransform } from '@angular/core';
import { convertToBoolean } from '@appbolaget/helpers';

@Pipe({
    name: 'boolean',
    standalone: true,
})
export class BooleanPipe implements PipeTransform {
    transform(value: any): any {
        return convertToBoolean(value);
    }
}
